export const addRoute = route => {
	return {
		type: "ADD_ROUTE",
		route
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/route.js